import { createSelector } from '@ngrx/store';
import { AppState } from '../../core/models/appState.model';
import { NotificationState } from './notification.reducer';

export const notificationSelector = createSelector(
  (state: AppState) => state.notification,
  (notify: NotificationState) => notify
);

export const selectLoading = createSelector(
  notificationSelector,
  (state: NotificationState) => state.isLoading
);